import { defineComponent as _defineComponent } from 'vue'
import IconService from '@/utils/icon-service';
import { computed } from 'vue';
import { STATUS_TO_SVG_MAP } from './WorkflowStatus.const';
import { NodeRunState, NodeRunStatuses } from '@ply-io/runner';


export default /*#__PURE__*/_defineComponent({
  __name: 'NodeRunStatus',
  props: {
    nodeRun: null
  },
  setup(__props: any) {

const props = __props as { nodeRun: NodeRunState }


const serviceIconURL = computed(() => IconService.getExternalIconUrl(props.nodeRun.serviceSlug));
// @ts-ignore
const actionStatusSvg = computed(() => STATUS_TO_SVG_MAP[props.nodeRun.status]);

const isThrottled = computed(() => props.nodeRun.status === NodeRunStatuses.Throttled);
const NUMBER_TO_NAME = ['first', 'second', 'third', 'fourth', 'fifth'];
const RATE_LIMIT_CODE = '429';
const SERVICE_UNAVAILABLE_CODE = '503';
const throttledMessage = computed(() => {
	const { nodeRun } = props; // action is not reactive
	if (isThrottled.value && nodeRun.retryDelay && nodeRun.retryCount) {
		// example: Slack says we're over the request limit. We will try again in 30 seconds (retrying for the first time).
		const numberOfTimes = NUMBER_TO_NAME[nodeRun.retryCount - 1] || NUMBER_TO_NAME[0];
		const suffixMessage = `We will try again in ${nodeRun.retryDelay} seconds (retrying for the ${numberOfTimes} time).`;
		if (nodeRun.retryReason === RATE_LIMIT_CODE) {
			return `${nodeRun.serviceSlug} says we're over the request limit. ${suffixMessage}`;
		} else if (nodeRun.retryReason === SERVICE_UNAVAILABLE_CODE) {
			return `${nodeRun.serviceSlug} is currently unavailable. ${suffixMessage}`;
		} else {
			return `${nodeRun.serviceSlug} requires retrying for some reason. ${suffixMessage}`;
		}
	}
	return '';
});

return { __sfc: true,props, serviceIconURL, actionStatusSvg, isThrottled, NUMBER_TO_NAME, RATE_LIMIT_CODE, SERVICE_UNAVAILABLE_CODE, throttledMessage }
}

})